import { AbstractControl, ValidationErrors } from '@angular/forms';

export function inputTextValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value || '';

  // Verificar si empieza con espacios en blanco o caracteres no permitidos al inicio (excepto diéresis)
  const startsWithInvalidChar = /^[\s.\-'"°]/.test(value);
  
  // Verificar longitud máxima
  const maxLengthValid = value.length <= 150;
  
  // Permitir letras, números, espacios, acentos, diéresis, punto, guion, apostrofe, comillas y símbolo de grado
  const validCharacters = /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ\s.\-'"°]*$/.test(value);

  const errors: ValidationErrors = {};
  if (startsWithInvalidChar) errors.startsWithSpace = true;
  if (!maxLengthValid) errors.maxLength = true;
  if (!validCharacters) errors.invalidCharacters = true;

  return Object.keys(errors).length > 0 ? errors : null;
}